import { render } from "./SpecialityView.vue?vue&type=template&id=44ff4685&scoped=true"
import script from "./SpecialityView.vue?vue&type=script&lang=js"
export * from "./SpecialityView.vue?vue&type=script&lang=js"

import "./SpecialityView.vue?vue&type=style&index=0&id=44ff4685&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ff4685"]])

export default __exports__